import { SETTINGS_VALUES } from '../../../ApiTokens/api-tokens.constants';
import AppRouter from 'common/AppRouter';
import _ from 'lodash';

export const validateInputs = (value, stateValue) => {
  const stateKey = _.get(stateValue, 'key');
  const valueKey = _.get(value, 'key');
  const stateRegex = _.get(stateValue, 'regex_pattern', '')?.trim();
  const valueRegex = _.get(value, 'regex_pattern', '')?.trim();
  if (stateKey !== valueKey) {
    if (
      stateKey === SETTINGS_VALUES.RELEASE_DETECTION.API_RELEASE_DETECTION &&
      _.get(stateValue, 'api_token_id')
    ) {
      return true;
    } else if (
      stateRegex !== '' &&
      stateKey !== SETTINGS_VALUES.RELEASE_DETECTION.API_RELEASE_DETECTION
    ) {
      return true;
    }
  } else if (valueRegex !== stateRegex && stateRegex !== '') {
    return true;
  }
  return false;
};

export const getReleaseDetectionSettingsSubtext = definitionLevel => {
  return definitionLevel === 'repository'
    ? 'Select the way you would like LinearB will detect releases.'
    : `Select the way you would like LinearB will detect releases.<br><strong>Note:</strong> This change will affect how LinearB detects your releases across all repositories.<br>To change the way releases are detected  for specific repositories only, <a href="${AppRouter.REPOSITORIES.path}" style="text-decoration:none">click here ></a>`;
};

export const getAdditionalDataObject = ({
  radioStates,
  radioValue,
  tokenExists,
  activeTokens
}) => {
  if (
    radioValue === SETTINGS_VALUES.RELEASE_DETECTION.API_RELEASE_DETECTION &&
    tokenExists
  ) {
    return {
      regex_pattern: null,
      api_token_id: activeTokens[0].id
    };
  }
  return {
    regex_pattern: radioStates[radioValue],
    api_token_id: null
  };
};
